import { Color } from "../../../../constants/V2/color"

import { TableRegex } from "@constants/tables"
import { getFillColorClass, stringToColor } from "@utils/V2/color"

export const extractFromTag = (text: string, tag: string): string => {
  return text
    .replace(new RegExp(`:${tag}\\("?`), "")
    .replace(new RegExp(`"?\\):`), "")
}

export const getThemeColor = (theme: "light" | "dark"): Color => {
  return theme === "light" ? Color.Charcoal : Color.White
}

export const getIconFillClass = (colorName?: string): string => {
  const color = stringToColor(colorName)
  return color ? getFillColorClass(color) : ""
}

export const getCheckmarkStrokeColor = (fillColor?: string): string => {
  return fillColor === "white" ? "stroke-blue" : "stroke-white"
}

export const getDashStrokeColor = (fillColor?: string): string => {
  return fillColor === "white" ? "stroke-black" : "stroke-white"
}

export const getCellBackgroundClass = (
  rowIndex: number,
  totalRows: number,
  theme: "light" | "dark",
  backgroundColor: Color
): string => {
  const isLastRow = rowIndex === totalRows - 1
  const isEvenRow = rowIndex % 2 === 0

  if (isLastRow) {
    if (theme === "light") return "bg-white"
    return backgroundColor === Color.Black ? "!bg-black" : "!bg-charcoal"
  }

  if (isEvenRow) {
    return theme === "light" ? "bg-white" : "bg-dark-gray"
  }

  if (theme === "light") return "bg-light-gray"
  return backgroundColor === Color.Black ? "bg-charcoal" : "bg-black"
}

export const getTooltipBackgroundColor = (
  theme: "light" | "dark",
  backgroundColor: Color
): Color => {
  if (theme === "light") {
    return backgroundColor === Color.Charcoal ? Color.Black : Color.Charcoal
  }
  return Color.White
}

export const parseContent = (
  regexMatch: RegExpMatchArray | null,
  prefixLength: number
): string[] => {
  return regexMatch
    ? regexMatch[0]
        .slice(prefixLength, -2)
        .split(",")
        .map((item) => item.trim())
    : []
}

export const extractPriceData = (item: any) => {
  return {
    priceSubScript: item.priceSubScript ?? item.priceSubscript ?? undefined,
    priceSideScript: item.priceSideScript ?? item.priceSidescript ?? undefined,
    promotionSavings: item.savingsAmount ? Number(item.savingsAmount) : 0,
    promotionStartDate: item.promotionStartDate ?? undefined,
    promotionEndDate: item.promotionEndDate ?? undefined,
  }
}

export const parseButtonData = (
  buttonMatch: RegExpMatchArray | null
): {
  buttonLabel?: string
  buttonLink?: string
  secondButtonLabel?: string
  secondButtonLink?: string
} => {
  if (!buttonMatch) return {}

  const [, firstLabel, firstLink, secondLabel, secondLink] = buttonMatch
  return {
    buttonLabel: firstLabel,
    buttonLink: firstLink,
    secondButtonLabel: secondLabel,
    secondButtonLink: secondLink,
  }
}

export const getCellRoundingClasses = (
  displayIndex: number,
  maxDesktopColumns: number
): Record<string, boolean> => {
  return {
    "sm:!rounded-r-none": displayIndex === 0,
    "rounded-l-none": displayIndex === 1,
    "sm:!rounded-l-none": displayIndex === maxDesktopColumns - 1,
    "sm:!rounded-none":
      displayIndex > 0 && displayIndex < maxDesktopColumns - 1,
    "rounded-r-none sm:rounded-r-10": displayIndex === 0,
    "rounded-l-none sm:rounded-l-10": displayIndex === maxDesktopColumns - 1,
  }
}

export const matchCellPatterns = (cellData: string) => {
  return {
    isCheckIcon: cellData.match(TableRegex.CHECK_ICON),
    isCrossIcon: cellData.match(TableRegex.CROSS_ICON),
    isCheckIconBlackStroke: cellData.match(TableRegex.CHECK_ICON_BLACK_STROKE),
    isDashIcon: cellData.match(TableRegex.DASH_ICON),
    isList: cellData.match(TableRegex.LIST),
    isPriceFromStoryblokSlug: cellData.match(
      TableRegex.PRICE_FROM_STORYBLOK_SLUG
    ),
    isDetailedPriceFromStoryblokSlug: cellData.match(
      TableRegex.DETAILED_PRICE_FROM_STORYBLOK_SLUG
    ),
    isPrice: cellData.match(TableRegex.PRICE),
    isButton: cellData.match(TableRegex.BUTTON),
    isHeader: cellData.match(TableRegex.HEADER),
    isProduct: cellData.match(TableRegex.PRODUCT),
    isBullet: cellData.match(TableRegex.BULLET),
  }
}
